module.exports = __webpack_public_path__ + "img/celsius.7e26af6a.svg";